import { Paper, Text } from "@mantine/core";
import { SiteName } from "../../utils/enums";

export interface FooterProps {
  height: number;
  siteName: SiteName;
}

const getCopyright = (siteName: SiteName) => {
  switch (siteName) {
    case SiteName.Optinode:
      return "node.energy GmbH";
    case SiteName.Smarendo:
      return "Rödl & Partner GmbH";
    case SiteName.Alva:
      return "Alva Energie GmbH";
    case SiteName.Wavelr:
      return "Wavelr GmbH";
    default:
      return "";
  }
};

function Footer({ height, siteName }: FooterProps) {
  return (
    <Paper component="footer" h={height} pl={30} radius={0}>
      <Text c="dimmed" fw={400} fz="xs">
        {new Date().getFullYear()} &copy; {getCopyright(siteName)}
      </Text>
    </Paper>
  );
}

export { Footer };
